import { SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_UPDATE_MEAL_PLAN_PATH_SUFFIX = "/meal-plan/update";
/** /customer/subscription/fresh/meal-plan/update */
export const SUBSCRIPTIONS_CUSTOMER_UPDATE_MEAL_PLAN_PATH = `${SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH}${SUBSCRIPTIONS_CUSTOMER_UPDATE_MEAL_PLAN_PATH_SUFFIX}`;
